(() => {
  const BRAND_VISUALS = {
    'brand-scott': {
      image: 'https://cdn.shopify.com/s/files/1/0621/0060/2968/files/scott-snowsports-hero-flow-blue-2026.jpg?v=1789175024',
      target: '/pages/scott'
    },
    'brand-dolomite': {
      image: 'https://cdn.shopify.com/s/files/1/0621/0060/2968/files/dolomite-f26-home-hero-54-denim-02.jpg?v=1791671967'
    },
    'brand-reima': {
      image: 'https://cdn.shopify.com/s/files/1/0621/0060/2968/files/reima-brand-hero.webp?v=1788902681',
      target: '/pages/reima'
    },
    'brand-dale_of_norway': {
      image: 'https://cdn.shopify.com/s/files/1/0621/0060/2968/files/dale-f26-home-hero-stalheim-outdoor-01.jpg?v=1791671954'
    }
  };

  const handleOf = (href) => {
    try {
      const match = new URL(href, window.location.origin).pathname.match(/^\/collections\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch {
      return '';
    }
  };

  const apply = (root = document) => {
    const scope = root?.querySelectorAll ? root : document;
    scope.querySelectorAll('.ps-mega__panel[data-panel$=":marken"] .ps-mega__visual[href]').forEach((card) => {
      const handle = handleOf(card.getAttribute('href'));
      const config = BRAND_VISUALS[handle];
      if (!config) return;

      if (config.target) card.setAttribute('href', config.target);

      let image = card.querySelector('img.ps-mega__visual-image');
      if (!image) {
        image = document.createElement('img');
        image.className = 'ps-mega__visual-image';
        image.loading = 'lazy';
        image.alt = '';
        const placeholder = card.querySelector('.ps-mega__visual-placeholder');
        if (placeholder) placeholder.replaceWith(image);
        else card.prepend(image);
      }
      if (image.src !== config.image) {
        image.src = config.image;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(document), { once: true });
  } else {
    apply(document);
  }
  document.addEventListener('shopify:section:load', (event) => apply(event.target));
  document.addEventListener('pointerover', (event) => {
    if (event.target.closest?.('[data-category="marken"]')) setTimeout(() => apply(document), 0);
  });
})();